import { IRequestCommand } from 'app/services/authentication/connection/iRequestCommand';
import { ErrorDetails } from 'app/services/authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from 'app/services/authentication/connection/commandRequestType';
import { ICommandResponse } from 'app/services/authentication/connection/iCommandResponse';

export class GetAssociatesByPrimaryPassengerIdCommand extends IRequestCommand<
  IGetAssociatesByPrimaryPassengerIdResponse,
  ErrorDetails,
  IGetAssociatesByPrimaryPassengerIdParameters> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'passengers/{passengerAccountId}/getFamilyGroupByPrincipal';

  public override setParameters(parameters: IGetAssociatesByPrimaryPassengerIdParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{passengerAccountId}',
      parameters.passengerAccountId ? parameters.passengerAccountId.toString() : ''
    );
  }
}

export interface IGetAssociatesByPrimaryPassengerIdParameters {
  passengerAccountId?: number;
}

export interface IGetAssociatesByPrimaryPassengerIdResponse extends ICommandResponse {
}
